export default function handleConvertToLower(text: string) {
  return text.toLowerCase();
}
